import Popover from './Popover';
import { StyledPopoverArea } from './PopoverStyles';


export const PopoverArea = StyledPopoverArea;

export default Popover;
